export const FETCH_LOGO_REVIEW_QUEUE = 'fetchLogoReviewQueue';
export const FETCH_LOGO_REVIEW_ITEM = 'fetchLogoReviewItem';
export const FETCH_LOGO_REVIEW_CANDIDATES = 'fetchLogoReviewCandidates';
export const FETCH_LOGO_REVIEW_STATS = 'fetchLogoReviewStats';
export const ACCEPT_LOGO_REVIEW = 'acceptLogoReview';
export const SKIP_LOGO_REVIEW = 'skipLogoReview';
export const TEXT_ICON_LOGO_REVIEW = 'textIconLogoReview';
export const FLAG_LOGO_REVIEW = 'flagLogoReview';
